export const COMPANY = {
  name: 'PuntUit',
  tagline: 'Externe Vertrouwenspersoon voor Nederland',
  email: 'info@puntuit.nl',
  phone: '085 – 107 12 56',
  whatsapp: '+31 6 28675690',
  addresses: [
    {
      street: 'Stammerhove 3',
      city: '1112 VA, Diemen',
    },
    {
      street: 'Vleerstraat 78',
      city: '2513 VJ, Den Haag',
    },
  ],
  kvk: '87786516',
  year: 2026,
};

// Contact zit niet in het menu: de "Kennismaken"-knop leidt al naar /contact
export const NAV_LINKS = [
  { name: 'De vertrouwenspersoon', href: '/externe-vertrouwenspersoon' },
  { name: 'Het PuntUit-spel', href: '/het-puntuit-spel' },
  { name: 'Preventie & bewustwording', href: '/preventie-ongewenst-gedrag' },
  { name: 'Voor mensen', href: '/voor-mensen' },
  { name: 'Tarieven', href: '/tarieven' },
  { name: 'Over PuntUit', href: '/over-ons' },
];

// Diensten-links voor de footer
export const SERVICE_LINKS = [
  { name: 'De vertrouwenspersoon', href: '/externe-vertrouwenspersoon' },
  { name: 'Het PuntUit-spel', href: '/het-puntuit-spel' },
  { name: 'Preventie & bewustwording', href: '/preventie-ongewenst-gedrag' },
  { name: 'Voor mensen', href: '/voor-mensen' },
];
